export enum DateType {
  RELATIVE = 'relative',
  ABSOLUTE = 'absolute',
}